import React from 'react';
import PropTypes from 'prop-types';
import { isMobileDevice } from '../../../../utils/deviceUtils';
import { vmin } from '../../../../utils/screenUtils';
import { getRandomNumber } from '../../../../utils/numUtils';

const hiddenCardXOffsets = [2, 4, -1, 7];
const hiddenCardYOffsets = [5, 2, 6, 2];

class VisibleCard extends React.Component {
  static propTypes = {
    card: PropTypes.string,
    allowed: PropTypes.bool,
    gameState: PropTypes.string,
    playCard: PropTypes.func.isRequired,
    currentTurnUid: PropTypes.string,
    memberUid: PropTypes.string,
    selectedCard: PropTypes.string,
    doubleClickSelectedCard: PropTypes.string,
    tableIsInProgress: PropTypes.bool.isRequired,
    cardsLength: PropTypes.number,
    index: PropTypes.number,
    hasPlayedCard: PropTypes.bool,
    hoveredCard: PropTypes.string,
    changeHoveredCard: PropTypes.func.isRequired,
    cardsOnTable: PropTypes.arrayOf(PropTypes.string),
    currentType: PropTypes.string,
    largePlayer: PropTypes.string,
    myPos: PropTypes.string,
    cardsOnLoading: PropTypes.bool,
    defaultCursor: PropTypes.bool,
    isDrunk: PropTypes.bool,
    screenHeight: PropTypes.number,
    isInInboxAppFrame: PropTypes.bool,
  }

  static defaultProps = {
    card: null,
    allowed: false,
    gameState: null,
    currentTurnUid: null,
    memberUid: null,
    selectedCard: null,
    doubleClickSelectedCard: null,
    cardsLength: 0,
    index: null,
    hasPlayedCard: null,
    hoveredCard: null,
    cardsOnTable: [],
    currentType: null,
    largePlayer: null,
    myPos: null,
    cardsOnLoading: true,
    defaultCursor: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      cardMoveClasses: this.getCardMoveClasses(getRandomNumber(0, 7)),
    };
  }
  
  getCardMoveClasses = (number) => {
    if (number === 0) {
      return ['drunk-move-up', 'drunk-move-down']
    }
    else if (number === 1) {
      return ['drunk-move-left', 'drunk-move-right']
    }
    else if (number === 2) {
      return ['drunk-move-down', 'drunk-move-up']
    }
    else if (number === 3) {
      return ['drunk-move-right', 'drunk-move-left']
    }
    else if (number === 4) {
      return ['drunk-move-up-2', 'drunk-move-down-2']
    }
    else if (number === 5) {
      return ['drunk-move-left-2', 'drunk-move-right-2']
    }
    else if (number === 6) {
      return ['drunk-move-down-2', 'drunk-move-up-2']
    }
    else if (number === 7) {
      return ['drunk-move-right-2', 'drunk-move-left-2']
    }
  };

  render() {
    const {
      cardsLength,
      card,
      allowed,
      nonPlayable,
      index,
      howerIndex,
      gameState,
      playCard,
      selectedCard,
      tableIsInProgress,
      memberUid,
      currentTurnUid,
      doubleClickSelectedCard,
      hasPlayedCard,
      hoveredCard,
      changeHoveredCard,
      cardsOnTable,
      currentType,
      largePlayer,
      myPos,
      cardsOnLoading,
      hasHiddenCard,
      isVisibleCard,
      defaultCursor,
      isDrunk,
      screenHeight,
      isInInboxAppFrame,
    } = this.props;

    const { cardMoveClasses } = this.state;

    let startIndex = 0;

    let hoveredClass = '';
    if (/*!nonPlayable && */allowed && currentTurnUid === memberUid) {
      // if (hoveredCard === `visible-${index}` && !isMobileDevice()) {
      //   hoveredClass = 'hovered';
      // }
      if (hoveredCard === index) {
        hoveredClass = 'hovered';
      }
    }

    let cardPos = window.innerWidth > 1280 ? {
      left: ((index) - 2) * vmin(24) / 2 - (vmin(2) / 2),
      // transform: `rotate(0deg)`,
      top: 50,
    } : {}

    const interpolateValues = {
      x1: 700, y1: isInInboxAppFrame ? 0.45 : 0.54,
      x2: 1200, y2: 1.0,
    }

    function interpolate(x, interpolateValues) {
      return interpolateValues.y1 + (x - interpolateValues.x1) * (interpolateValues.y2 - interpolateValues.y1) / (interpolateValues.x2 - interpolateValues.x1);
    }

    function interpolateClamped(x, interpolateValues) {
      const result = interpolate(x, interpolateValues);
      return Math.min(interpolateValues.y2, Math.max(interpolateValues.y1, result));
    }

    const cardSizeMultiplier = interpolateClamped(screenHeight, interpolateValues);

    const blockedCard = !hasPlayedCard && currentTurnUid && memberUid === currentTurnUid && !allowed && gameState && gameState !== 'choose' && !tableIsInProgress;

    const isCurrentTurn = currentTurnUid === memberUid;
    const canBePlayed = !nonPlayable && allowed;

    return (
        <div
          className={`student-zole-card-wrapper mx-1 my-1`}
          style={{width: 90 * cardSizeMultiplier, height: 132 * cardSizeMultiplier}}
        >
          {hasHiddenCard && (
            <div
              className={`student-zole-card-hidden`}
            >
              <div
                className={`${blockedCard ? 'blocked-overlay' : 'display-none'}`}
              >
              </div>
            </div>
          )}
          {card && (
            <div
            id={`hand-card-${card}`}
            className={`card-${card} student-zole-card  ${hasHiddenCard ? '' : 'student-zole-card-without-hidden'} ${(isCurrentTurn && gameState !== 'choose' && canBePlayed) && 'student-zole-card-current-turn'} ${blockedCard && 'student-zole-card-blocked'} ${isDrunk && cardMoveClasses[0]} ${(allowed && gameState && gameState !== 'choose' && gameState !== 'results' && !tableIsInProgress) ? 'allowed2' : 'blocked'}`}
            style={{ cursor: nonPlayable ? 'default' : 'pointer', width: '100%', height: '100%', backgroundPosition: 'center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}}
              onClick={e => {
                if (!isCurrentTurn) return;
                if (!canBePlayed) return;
                playCard(e, { card, allowed });
              }}
              onMouseOver={() => changeHoveredCard(index, card, 'over')}
              onFocus={() => changeHoveredCard(index, card, 'over')}
              onMouseOut={() => changeHoveredCard(index, card, 'out')}
              onBlur={() => changeHoveredCard(index, card, 'out')}
            
            >
              <div
                className={`${blockedCard ? 'blocked-overlay' : 'display-none'}`}
              >
              </div>
            </div>
          )}

          {isDrunk && card && (
            <div
            className={`card-${card} student-zole-card  ${hasHiddenCard ? '' : 'student-zole-card-without-hidden'} ${(isCurrentTurn && canBePlayed) && 'student-zole-card-current-turn'} ${blockedCard && 'student-zole-card-blocked'} ${cardMoveClasses[1]} ${(allowed && gameState && gameState !== 'choose' && gameState !== 'results' && !tableIsInProgress) ? 'allowed2' : 'blocked'}`}
            style={{ cursor: nonPlayable ? 'default' : 'pointer', width: '100%', height: '100%', backgroundPosition: 'center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', opacity: 0.5}}
              onClick={e => {
                if (!isCurrentTurn) return;
                if (!canBePlayed) return;
                playCard(e, { card, allowed });
              }}
              onMouseOver={() => changeHoveredCard(index, card, 'over')}
              onFocus={() => changeHoveredCard(index, card, 'over')}
              onMouseOut={() => changeHoveredCard(index, card, 'out')}
              onBlur={() => changeHoveredCard(index, card, 'out')}
            
            >
              <div
                className={`${blockedCard ? 'blocked-overlay' : 'display-none'}`}
              >

              </div>
            </div>
          )}
        </div>
        //   <div key={`hover-${card}`} style={{ zIndex: (990 - index) }}>
        //     {(card && hasHiddenCard) ? (
        //       <div
        //         key={`hidden-card-${card}`}
        //         id={`hidden-card-${card}`}
        //         style={{...cardPos, pointerEvents: 'none'}}
        //         className={`card2-wrapper student-zole-hidden-card student-zole-card-${startIndex + index} ${(allowed && gameState && gameState !== 'choose' && gameState !== 'results' && !tableIsInProgress) ? 'allowed2' : 'blocked'}`}
        //       >
        //         <div className="card2-innerWrapper" style={{ top: (-10 + hiddenCardYOffsets[index]), right: (5 + hiddenCardXOffsets[index]) }}>
        //           {card ? (
        //             <>
        //               <div className={cardsOnTable.length === 2 && cardsOnTable && cardsOnTable.includes(card) && gameState && largePlayer && largePlayer === myPos && (gameState === 'burry') && 'take-redesign-card'} />
        //               <div className={`card2 card2-on-table card2-hidden ${(selectedCard === card || (doubleClickSelectedCard === card)) ? 'selected' : ''} `} style={defaultCursor ? {cursor: 'default', pointerEvents: 'all'} : {pointerEvents: 'all'} }>
        //                 <div
        //                   key={`overlay-${card}`}
        //                   id={`hand-card-overlay-${card}`}
        //                   className={`${((!hasPlayedCard && currentTurnUid && memberUid === currentTurnUid && !allowed && gameState && gameState !== 'choose' && !tableIsInProgress)) ? 'blocked-overlay' : 'display-none'}`}
        //                 />
        //               </div>
        //             </>
        //           ) : (null)}
        //         </div>
        //       </div>
        //     ) : (null)}

        //     <div className={`${hoveredClass}`}>
        //       <div
        //         key={`visible-card-${card}`}
        //         id={`hand-card-${card}`}
        //         style={{ pointerEvents: card ? 'none' : 'none', ...cardPos }}
        //           className={`${hoveredClass} card2-wrapper student-zole-card-${startIndex + index} ${(allowed && gameState && gameState !== 'choose' && gameState !== 'results' && !tableIsInProgress) ? 'allowed2' : 'blocked'}`}
        //           onClick={e => playCard(e, { card, allowed: (!nonPlayable && allowed) })}
        //           onMouseOver={() => changeHoveredCard(`visible-${index}`, card, 'over', (!nonPlayable && allowed))}
        //           onFocus={() => changeHoveredCard(`visible-${index}`, card, 'over', (!nonPlayable && allowed))}
        //           onMouseOut={() => changeHoveredCard(`visible-${index}`, card, 'out', (!nonPlayable && allowed))}
        //           onBlur={() => changeHoveredCard(`visible-${index}`, card, 'out', (!nonPlayable && allowed))}
        //       >
        //         <div className={`card2-innerWrapper ${isDrunk && cardMoveClasses[0]} ${isDrunk && 'pulse-blur'}`}>
        //           {card ? (
        //             <>
        //               <div className={cardsOnTable.length === 2 && cardsOnTable && cardsOnTable.includes(card) && gameState && largePlayer && largePlayer === myPos && (gameState === 'burry') && 'take-redesign-card'} />
        //               <div className={`card2 card2-on-table card2-${card} ${(selectedCard === card || (doubleClickSelectedCard === card)) ? 'selected' : ''} `} style={defaultCursor ? {cursor: 'default', pointerEvents: 'all'} : {pointerEvents: 'all'} }>
        //                 <div
        //                   key={`overlay-${card}`}
        //                   id={`hand-card-overlay-${card}`}
        //                   className={`${((!hasPlayedCard && currentTurnUid && memberUid === currentTurnUid && !allowed && gameState && gameState !== 'choose' && !tableIsInProgress)) ? 'blocked-overlay' : 'display-none'}`}
        //                   onClick={e => playCard(e, { card, allowed })}
        //                 />
        //               </div>
        //             </>
        //           ) : (null)}
        //         </div>

        //         {isDrunk && (
        //           <div className={`aaaa-card2-innerWrapper-test card2-innerWrapper ${cardMoveClasses[1]} pulse-blur`} style={{position: 'absolute', top: 0, left: 0}}>
        //             {card ? (
        //               <>
        //                 <div className={cardsOnTable.length === 2 && cardsOnTable && cardsOnTable.includes(card) && gameState && largePlayer && largePlayer === myPos && (gameState === 'burry') && 'take-redesign-card'} />
        //                 <div className={`card2 card2-on-table card2-${card} ${(selectedCard === card || (doubleClickSelectedCard === card)) ? 'selected' : ''} `} style={defaultCursor ? {cursor: 'default', pointerEvents: 'all'} : {pointerEvents: 'all'} }>
        //                   <div
        //                     key={`overlay-${card}`}
        //                     id={`hand-card-overlay-${card}`}
        //                     className={`${((!hasPlayedCard && currentTurnUid && memberUid === currentTurnUid && !allowed && gameState && gameState !== 'choose' && !tableIsInProgress)) ? 'blocked-overlay' : 'display-none'}`}
        //                     onClick={e => playCard(e, { card, allowed })}
        //                   />
        //                 </div>
        //               </>
        //             ) : (null)}
        //           </div>
        //         )}
        //       </div>
        //     </div>
        //   </div>
    );
  }
}


export default (VisibleCard);
